<div class="w-100 d-flex flex-row justify-content-between align-items-center flex-grow-1 me-0 ms-0">
    <div class="ms-4 d-flex justify-content-center" >
        <a href="https://rekbot.pl/polityka-prywatnosci/" target="_new" class="privacy-link mt-2">Polityka prywatności</a>
    </div>
    <app-copyright class="d-flex justify-content-center"></app-copyright>
</div>
